export default "__VITE_ASSET__df0deb05__"